/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Deal_Splits_Delete_ConfirmInputs */

const cs_deal_splits_delete_confirm = /** @type {(inputs: Deal_Splits_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odebrat podíl pro „${i?.name}“?`)
};

const en_deal_splits_delete_confirm = /** @type {(inputs: Deal_Splits_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove the split for “${i?.name}”?`)
};

/**
* | output |
* | --- |
* | "Remove the split for “{name}”?" |
*
* @param {Deal_Splits_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_delete_confirm = /** @type {((inputs: Deal_Splits_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_delete_confirm(inputs)
	return cs_deal_splits_delete_confirm(inputs)
});